<!--BEGIN CONTENT-->
<app-notify-message></app-notify-message>

@if (showAlert) {
  <div class="row">
    <div class="col-md-12">
      <alert [type]="alertType" [dismissible]="true" (onClosed)="showAlert = false">
        {{ alertMessage }}
      </alert>
    </div>
  </div>
}

<div class="row">
  <!-- <div class="col-md-3 col-lg-2 components-side-menu pr-0">
  <app-side-menu [sideData]="message"></app-side-menu>
</div> -->
<!-- <div class="col-md-9 col-sm-12 col-lg-10 pl-1 fullheight"> -->
<div class="col fullheight">
  @if (!isLoading) {
    <section id="main_content" class="bg">
      <div class="row">
        <div class="col-md-12 text-center">
          <h3 class="headingVehicleAdd font400 mt-2 page-heading">{{companyName}}</h3>
          <form (ngSubmit)="f.form.valid && onSearch()" #f="ngForm" novalidate class="col-lg-12 search-wrapper mt-2">
            <div class="select-container text-left">
              <select required class="form-control" [(ngModel)]="searchModel.searchType" name="searchType"
                #searchType="ngModel" (change)="onSlotChange($event); selectInput()">
                <!-- <optgroup label="User"> -->
                <option value="email">Email</option>
                <option value="username">Username</option>
                <option value="phoneNumber">Mobile Number</option>
                <option value="chargerId">Charger ID</option>
                <!-- <option value="firstName">First Name</option>
                <option value="lastName">Last Name</option>
                <option value="mobileNumber">Mobile Number</option>
                <option value="customerId">Customer Id</option>
              </optgroup>
              <optgroup label="Device">
                <option value="assetName">Name</option>
                <option value="serialNumber">Serial Number</option>
                <option value="productSerialNumber">Product Serial Number</option>
                <option value="imei">IMEI</option>
                <option value="simCcid">SIM CCID</option>
                <option value="vin">VIN</option>
                <option value="firmwareVersion">Firmware Version</option>
                <option value="configVersion">Config Version</option>
                <option value="deviceId">Device ID</option> -->
                <!-- <option value="groupName">Group Name</option> -->
                <!-- <option value="mobileNumber">SIM Mobile Number</option> -->
                <!-- <option value="groupId">Group ID</option> -->
              <!-- </optgroup> -->
            </select>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
            @if (f.submitted && searchType.invalid) {
              <div class="alert-container">
                @if (searchType.errors?.['required']) {
                  <small class="text-danger">Please select type</small>
                }
              </div>
            }
          </div>
          <div class="container-input">
            <input #inputElement (keyup)="inputValidator($event)" placeholder="Search" type="text" name="supportTypeVal" required [(ngModel)]="searchModel.supportTypeVal"
              #supportTypeVal="ngModel" [autofocus]="true" [maxlength]="searchModel.searchType === 'phoneNumber' ? 15 : null">
              <i class="fa fa-search img-responsive search-icon cursor-pointer" aria-hidden="true"></i>
              <!--<i class="fa fa-times clear" aria-hidden="true" *ngIf="searchModel.supportTypeVal!=''" (click)="clear()"></i>-->
              <!--<div class="alert-container" *ngIf="f.submitted && supportTypeVal.invalid">-->
              <!--<small *ngIf="supportTypeVal.errors.required" class="text-danger">Please write some text</small>-->
            <!--</div>-->
          </div>
          <!--<div class="button-container small-screen-btn">-->
          <!--<button class="btn btn-primary"><i class="fa fa-search mr-1"></i>Search</button>-->
        <!--</div>-->
      </form>
    </div>
  </div>
  @if (users.length>0) {
    <div class="row">
      <div class="col-12">
        <div class="w90 col mt-4">
          <ngx-datatable
            id="tableau" #dataTable
            class="bootstrap alertTable registeredVehicle reportsTable wrapcell"
            [rows]="users"
            [columnMode]="'force'"
            [headerHeight]="50"
            [footerHeight]="50"
            [rowHeight]="'auto'"
            [summaryRow]="false"
            [scrollbarH]="true"
            [reorderable]="true">
            <ngx-datatable-column [resizeable]="false" [sortable]="false" name="#" [width]="50">
              <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                {{rowIndex+1}}
              </ng-template>
            </ngx-datatable-column>
            <!-- <ngx-datatable-column [resizeable]="false" name="Name" prop="firstName">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.firstName}} {{row.lastName}}
              </ng-template>
            </ngx-datatable-column> -->
            <!-- <ngx-datatable-column [resizeable]="false" name="Email" prop="emailId">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.emailId}}
              </ng-template>
            </ngx-datatable-column> -->
            <ngx-datatable-column [resizeable]="false" name="User Name" prop="userName">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.userName}}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [resizeable]="false" name="Customer ID" prop="customerId" [width]="130">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.customerId}}
              </ng-template>
            </ngx-datatable-column>
            <!-- Phone Number column removed as per requirement -->
            <!--
            <ngx-datatable-column name="Phone Number" [sortable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.mobileNumber}}
              </ng-template>
            </ngx-datatable-column>
            -->
            <!-- Type column removed -->
            <!--
            <ngx-datatable-column name="Type" prop="userType">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.userType}}
              </ng-template>
            </ngx-datatable-column>
            -->
            <!-- Created At column removed -->
            <!--
            <ngx-datatable-column name="Created At" prop="createdAt">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.createdAt | date: isoDateTimeFormat}}
              </ng-template>
            </ngx-datatable-column>
            -->
            <!-- SHOW button column removed -->
            <ngx-datatable-column [resizeable]="false" [sortable]="false" [width]="200">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <!-- <button type="button" class="btn btn-outline-primary btn-sm mr-2"
                (click)="getCurrentUser(row);">SHOW
              </button> -->
              @if (impersonatePermission && impersonatePermission.authorities.includes('READ') && (row.userType=='SUB_USER' || row.userType=='SUPER_USER')) {
                <button
                  class="btn btn-primary btn-sm view-button"
                  (click)="impersonateUser(row)">
                  <i class="fa fa-eye text-white"></i>View
                </button>
              }
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
}
@if (devices.length>0) {
  <div class="row">
    <div class="col-12">
      <div class="w90 col mt-4">
        <ngx-datatable
          id="tableau" #dataTable
          class="bootstrap alertTable registeredVehicle reportsTable wrapcell"
          [rows]="devices"
          [columnMode]="'force'"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          [summaryRow]="false"
          [scrollbarH]="true"
          [reorderable]="true">
          <ngx-datatable-column [resizeable]="false" [sortable]="false" name="#" [width]="50">
            <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
              {{rowIndex+1}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Device ID" prop="deviceId">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{row.deviceId}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Name" prop="assetName">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{row.assetName}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Serial Number" prop="serialNumber">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{row.serialNumber}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="PSN" prop="productSerialNumber">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{row.productSerialNumber}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="IMEI" prop="imei">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{row.imei}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="VIN" prop="vin">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{row.vin}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Firmware Version" prop="firmwareVersion">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{row.firmwareVersion}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Config Version" prop="configVersion">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{row.configVersion}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="SIM CCID" prop="simCcid">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{row.simCcid}}
            </ng-template>
          </ngx-datatable-column>
          <!-- <ngx-datatable-column name="SIM Mobile Number" >
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.mobileNumber}}
          </ng-template>
        </ngx-datatable-column> -->
              <ngx-datatable-column name="Customer ID" prop="customerId" [width]="130">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.customerId}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Status" [sortable]="false" [width]="130">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <span [class]="'class-' + deviceStatusClass[row.deviceStatus]">
                    {{deviceStatus[row.deviceStatus]}}
                  </span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Last Communication" prop="lastCommunication">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.lastCommunication | date: isoDateTimeFormat}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Received At" prop="receivedAt">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.receivedAt | date: isoDateTimeFormat}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Created At" prop="createdAt">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.createdAt | date: isoDateTimeFormat}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column [sortable]="false" [width]="200">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <button type="button" class="btn btn-outline-primary btn-icon-left mr-2"
                    (click)="getCustomerId(row.customerId);">SHOW
                  </button>
                  @if (impersonatePermission && impersonatePermission.authorities.includes('READ') &&
                  (row.userType=='SUB_USER' || row.userType=='SUPER_USER')) {
                  <button class="btn btn-primary btn-sm" (click)="impersonateUser(row)">
                    <i class="fa fa-sign-out text-white"></i>Impersonate
                  </button>
                  }
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
        </div>
      </div>
      }
      @if (vehicles.length>0) {
      <div class="row">
        <div class="col-12">
          <div class="w90 col mt-4">
            <ngx-datatable id="tableau" #dataTable class="bootstrap alertTable registeredVehicle reportsTable wrapcell"
              [rows]="vehicles" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'"
              [summaryRow]="false" [scrollbarH]="true" [reorderable]="true">
              <ngx-datatable-column [resizeable]="false" [sortable]="false" name="#" [width]="50">
                <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                  {{rowIndex+1}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Vehicle ID" prop="deviceId">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.deviceId}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Name" prop="assetName">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.assetName}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="VIN" prop="vin">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.vin}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Serial Number" prop="serialNumber">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.serialNumber}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Group Name" prop="groupName">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.groupName}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Customer ID" prop="customerId" [width]="130">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.customerId}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Tags" prop="tags">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.tags}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Last Communication" prop="lastCommunication">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.lastCommunication | date: isoDateTimeFormat}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Received At" prop="receivedAt">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.receivedAt | date: isoDateTimeFormat}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Created At" prop="createdAt">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.createdAt | date: isoDateTimeFormat}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column [sortable]="false" [width]="200">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <button type="button" class="btn btn-peak btn-danger btn-icon-left mr-2"
                    (click)="getCustomerId(row.customerId);">SHOW
                  </button>
                  @if (impersonatePermission && impersonatePermission.authorities.includes('READ') &&
                  (row.userType=='SUB_USER' || row.userType=='SUPER_USER')) {
                  <button class="btn btn-primary btn-sm" (click)="impersonateUser(row)">
                    <i class="fa fa-sign-out text-white"></i>Impersonate
                  </button>
                  }
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
        </div>
      </div>
      }
      @if (noResults) {
      <div class="col-12 text-center my-5">
        <br><br><br>
        <img width="170" src="../../../assets/img/info_nodata_256.png" />
        <h4 class="mt-3">No data to show</h4>
        @if (searchModel.searchGroup === 'User') {
        <div class="jira-ticket-section mt-4">
          <p>Having issues? Our support team is here to help.</p>
          <button class="btn btn-accent" disabled="true" (click)="openJiraTicketModal()">
            <i class="fa fa-bug"></i> Create Jira Ticket
          </button>
        </div>
        }
      </div>
      }
    </section>
    }

    <!-- Jira Ticket Modal Overlay -->
    @if (showJiraTicketModal) {
    <div class="modal-overlay" (click)="closeJiraTicketModal()">
      <div class="modal-content" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <h2> <b>Create Jira Ticket</b></h2>
          <button class="modal-close-button" (click)="closeJiraTicketModal()">×</button>
        </div>
        <div class="modal-body">
          <form #jiraTicketForm="ngForm" (ngSubmit)="createJiraTicket(jiraTicketForm)">
            <!-- Customer Account ID -->
            <div class="form-group">
              <label for="customerAccountId">Customer Account ID</label>
              <input type="text" id="customerAccountId" name="customerAccountId" [(ngModel)]="jira.customerAccountId"
                required class="form-control" placeholder="Enter customer account ID" #customerAccountId="ngModel">
              @if (jiraTicketForm.submitted && customerAccountId.invalid) {
              <div class="alert-container">
                @if (customerAccountId.errors?.['required']) {
                <small class="text-danger">Customer Account ID is required</small>
                }
              </div>
              }
            </div>
            <!-- Customer Contact (email/username) -->
            <div class="form-group">
              <label for="customerContact">Customer Contact</label>
              <input type="email" id="customerContact" name="customerContact" [(ngModel)]="jira.customerEmail" required
                email class="form-control" placeholder="Enter customer email" #customerContact="ngModel">
              @if (jiraTicketForm.submitted && customerContact.invalid) {
              <div class="alert-container">
                @if (customerContact.errors?.['required']) {
                <small class="text-danger">Customer email is required</small>
                }
                @if (customerContact.errors?.['email']) {
                <small class="text-danger">Please enter a valid email address</small>
                }
              </div>
              }
            </div>
            <!-- Problem Description -->
            <div class="form-group">
              <label for="problemDescription">Problem Description</label>
              <textarea id="problemDescription" name="problemDescription" rows="6" [(ngModel)]="jira.description"
                required minlength="10" class="form-control" (ngModelChange)="updateCharCount()"></textarea>
              <div class="char-count">Minimum 10 characters required. Current: {{ jira.description.length
                }}</div>
            </div>
            <!-- Attachments -->
            <div class="form-group attachments-section">
              <label>Attachments</label>
              <div class="attachment-drop-zone" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)" (click)="fileInput.click()">
                <input type="file" #fileInput (change)="onFileSelected($event)" multiple hidden>
                <i class="fa fa-upload"></i>
                <p>Click to upload or drag and drop files here</p>
                <p class="supported-files">Supported: .log, .txt, .zip, .pdf, .png, .jpg</p>
              </div>
              @if (jira.attachments.length) {
              <div class="attachment-previews">
                @for (file of jira.attachments; track file; let i = $index) {
                <div class="attachment-preview">
                  <span>{{ file.name }}</span>
                  <button (click)="removeAttachment(i)" class="remove-attachment-btn">×</button>
                </div>
                }
              </div>
              }
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-tertiary" (click)="closeJiraTicketModal()">Cancel</button>
          <button type="submit" class="btn btn-primary"
            [disabled]="!jiraTicketForm.form.valid || !jira.customerAccountId || !jira.customerEmail"
            (click)="createJiraTicket(jiraTicketForm)">Create</button>
        </div>
      </div>
    </div>
    }
  </div>
</div>